const Strings = [
  "Guitar",
  "Bass",
  "Banjo",
  "Viola",
  "Chello",
  "Violin",
  "Fiddle",
  "Harpsichord",
  "Vocals",
];

const Keyboard = ["Piano", "Organ", "Electronic", "Keyboard", "Synthesizer"];

const Brass = ["Trumpet", "Trombone", "Tuba", "Horn"];

const Percussion = ["Drums", "Cymbals", "Tambourine", "Cowbell", "Xylophone"];

const Woodwind = [
  "Saxophone",
  "Flute",
  "Clarinet",
  "Oboe",
  "Bassoon",
  "Harmonica",
];

const otherSkills = [
  "Producer",
  "Mixing Engineer",
  "Mastering Engineer",
  "Engineer",
  "Songwriter",
  "Editor",
  "Video Editor",
  "Graphic Designer",
];

const dawSkills = [
  "Ableton",
  "Pro Tools",
  "Logic",
  "FL Studio",
  "Garage Band",
  "Audacity",
];

export const SkillsArray = [
  ...Strings,
  ...Keyboard,
  ...Brass,
  ...Percussion,
  ...Woodwind,
  ...otherSkills,
  ...dawSkills,
].sort();

export const GenresArray = [
  "Avant-garde",
  "Alternative Rock",
  "Anime",
  "Blues",
  "Classical",
  "Classic Rock",
  "Children's music",
  "Comedy",
  "Country",
  "Commercial",
  "Easy listening",
  "Electronic",
  "Folk",
  "Hip-Hop / Rap",
  "Holiday",
  "House",
  "Pop",
  "Religious",
  "Jazz",
  "Metal Rock ",
  "New Age",
  "Punk Rock",
  "Opera",
  "R&B / Soul",
  "Reggae",
  "Rock",
  "International",
  "Emo",
  "Pop Punk",
  "Singer-Songwriter",
  "Acoustic",
].sort();

export const inviteList = [];
export const websiteRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
export const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
